
import Vue from 'vue'

const getDefaultState = () => {
    return {
        workOrderRequest: {
          id: 0,
        },
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async GetById( { commit }, idWorkOrderRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`workorder-request/${idWorkOrderRequest}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                const workOrderRequestResponse = result.data;

                commit('saveState', workOrderRequestResponse);

                return workOrderRequestResponse;
            }
            else {
                return false
            }
        }
        catch(ex) {
            console.log("Error to get work order request", ex);
            return false;
        }
    },

    async ListNotification() {

        try {

            const result = await Vue.prototype.$vanKirkApi.get("workorder-request/list-notification",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                return result.data.result;
            }
            else {
                return 0;
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list notification work order request: [${ex}]`
            };
        }
    },

    async List() {

        try {

            const result = await Vue.prototype.$vanKirkApi.get("workorder-request/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listWorkOrderRequest = result.data.result;
                return listWorkOrderRequest;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list work order request : [${ex}]`
            };
        }
    },

    async ListTodaySchedule() {

        try {

            const result = await Vue.prototype.$vanKirkApi.get("workorder-request/list-today-schedule",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listWorkOrderRequest = result.data.result;
                return listWorkOrderRequest;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list work order request: [${ex}]`
            };
        }
    },

    async ListOpen() {

        try {

            const result = await Vue.prototype.$vanKirkApi.get("workorder-request/list-open",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listWorkOrderRequest = result.data.result;
                return listWorkOrderRequest;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list work order request: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, workOrderRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`workorder-request/create-update`, workOrderRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (workOrderRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    workOrderRequestResponse: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {

                let message = `Error to create/update register: [${error.response.data}]`;

                if (error.response.data.toString().includes("ExistsWO")) {
                    message = error.response.data;
                }

                return {
                    success: false,
                    message
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, updateStatusRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`workorder-request/update-status/${updateStatusRequest.id}`, updateStatusRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with successfully"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async ListStatus() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`workorder-request/list-status`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listStatus = result.data.result;

                return listStatus;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list status: [${ex}]`
            };
        }
    },

    async CheckExistsLinkedItems( _, idServiceProject) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`workorder-request/check-exists-linked-items/${idServiceProject}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return result.data.result.idWorkOrderRequest;
            }
            else {
                return false
            }
        }
        catch(ex) {
            console.log("Error to check linked items", ex);
            return false;
        }
    },

    async UpdateOrder(_, updateOrderRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`workorder-request/update-order/${updateOrderRequest.id}/${updateOrderRequest.order}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Order updated with successfully"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the order!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the order: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.workOrderRequest, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.workOrderRequest;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
